import { render } from "./weeklySaleChartDashboardPanel.vue?vue&type=template&id=2fd8ab34"
import script from "./weeklySaleChartDashboardPanel.vue?vue&type=script&lang=js"
export * from "./weeklySaleChartDashboardPanel.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Git\\VueTemplate\\A1Catering\\a1cateringadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__